module.exports = __webpack_public_path__ + "img/star-4.c71a3cf0.svg";